import config from '../config';
import { getToken } from './auth';

const MONITORING_BASE = `${config.api.baseURL}/api/v1/monitoring`;

/**
 * Get model comparison statistics
 */
export const getModelComparisonStats = async (workspaceId, hours = 24, projectId = null) => {
  const token = getToken();
  
  const response = await fetch(`${MONITORING_BASE}/model-comparison-stats`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      workspace_id: workspaceId,
      hours,
      project_id: projectId
    })
  });

  if (!response.ok) {
    throw new Error('Failed to fetch stats');
  }

  const result = await response.json();
  return result.data;
};

/**
 * Get model comparison breakdown
 */
export const getModelComparisonBreakdown = async (workspaceId, hours = 24) => {
  const token = getToken();
  
  const response = await fetch(`${MONITORING_BASE}/model-comparison-breakdown`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      workspace_id: workspaceId,
      hours
    })
  });

  if (!response.ok) {
    throw new Error('Failed to fetch breakdown');
  }

  const result = await response.json();
  return result.data;
};

/**
 * Get recent model comparisons
 */
export const getRecentModelComparisons = async (workspaceId, limit = 50, projectId = null) => {
  const token = getToken();
  
  const response = await fetch(`${MONITORING_BASE}/recent-model-comparisons`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      workspace_id: workspaceId,
      limit,
      project_id: projectId
    })
  });

  if (!response.ok) {
    throw new Error('Failed to fetch recent comparisons');
  }

  const result = await response.json();
  return result.data;
};

